import { useKeycloak } from "@react-keycloak/web";

interface UseUser {
  user: any;
}

export const useUser = (): UseUser => {
  const { keycloak } = useKeycloak();

  const { idTokenParsed } = keycloak;

  return {
    user: idTokenParsed,
  };
};
